module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "never",
      "header": "基本信息"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "商城名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.brand_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "brand_name", $$v)
      },
      expression: "form.brand_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商城简介"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": 120,
      "rows": 6,
      "placeholder": "请输入商城简介"
    },
    on: {
      "input": _vm.countInput
    },
    model: {
      value: (_vm.form.intro),
      callback: function($$v) {
        _vm.$set(_vm.form, "intro", $$v)
      },
      expression: "form.intro"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right muted"
  }, [_vm._v(_vm._s(_vm.remnant) + "/120")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商城Logo"
    }
  }, [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.form.logo,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgChange
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer content-center"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2cf8b05c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cf8b05c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shop/shopsetting.vue
// module id = 2577
// module chunks = 0